export interface WelcomeNextStep {
  title: string
  description: string
}

export const welcomeNextSteps: WelcomeNextStep[] = [
  {
    title: 'Complete your profile',
    description: 'Tell clients about your practice and areas of expertise.',
  },
  {
    title: 'Add your services and availability',
    description: 'Set up your appointment types, pricing and availability.',
  },
  {
    title: 'Submit for verification',
    description: 'Fem Entity will review your credentials before your profile goes live.',
  },
  {
    title: 'Start connecting with clients',
    description: 'Once approved, your profile can become available for matching.',
  },
]
